import { IApplicationState } from '../../types/redux';

export const getGeneralRating = (state: IApplicationState): number | null => {
  return state.newReview.data.generalRating.value;
};
